@if (!refreshing) {
  <div class="capture-detail">
    @switch (capture.status) {
      @case (captureStatuses.verifiedClientPrescription) {
        <div class="capture-fixed mb-1">
          <app-capture-header [capture]="capture" />
          <div class="mt-1 capture-nav">
            <app-capture-nav
              [capture]="capture"
              [currentSection]="currentSection"
              (sectionClick)="onSectionClick($event)"
              />
          </div>
        </div>
        <div
          id="captureScrollable"
          class="capture-scrollable"
          appScrollSpy
          [spiedTags]="['SECTION']"
          (sectionChange)="onSectionScroll($event)"
          >
          @if (showValidateReferralSection) {
            <section id="validateReferral">
              <app-validate-referral
                [capture]="capture"
                [patientPrescriber]="patientPrescriber" />
            </section>
          }
          <section id="ceReviewDetails"><app-ce-review-details [capture]="capture" /></section>
          <section id="patientPrescriptions">
            <app-patient-prescriptions [capture]="capture" />
          </section>
          @if (showClientPrescriptionMatches) {
            <section id="clientPrescriptionMatches"
              >
              <app-client-prescription-matches [capture]="capture" />
            </section>
          }
          <section id="validatePatientCareOwnership">
            <app-validate-patient-care-ownership [capture]="capture" />
          </section>
          <section id="captureVerification">
            <app-capture-verification
              [capture]="capture"
              [patientPrescriber]="patientPrescriber"
              />
          </section>
          @if (capture.userAuditable || capture.userAuditOutcome) {
            <section id="captureUserAudit">
              <app-capture-user-audit [capture]="capture" />
            </section>
          }
        </div>
      }
      @case (captureStatuses.needsPatientMatchApproval) {
        <div class="mb-3"><app-capture-header [capture]="capture" /></div>
        <div class="ps-3">
          <section><app-needs-patient-match-approval [capture]="capture" /></section>
        </div>
      }
      @case (captureStatuses.needsReferralMatchApproval) {
        <div class="mb-3"><app-capture-header [capture]="capture" /></div>
        <div>
          <section>
            <app-needs-referral-match-approval
              [capture]="capture"
              [patientPrescriber]="patientPrescriber"
              />
          </section>
        </div>
      }
      @case (captureStatuses.verifiedClientHasConsultNote) {
        <div class="capture-fixed mb-1">
          <app-capture-header [capture]="capture" />
          <div class="mt-1 capture-nav">
            <app-capture-nav
              [capture]="capture"
              [currentSection]="currentSection"
              (sectionClick)="onSectionClick($event)"
              />
          </div>
        </div>
        <div
          id="captureScrollable"
          class="capture-scrollable"
          appScrollSpy
          [spiedTags]="['SECTION']"
          (sectionChange)="onSectionScroll($event)"
          >
          <section id="validateReferral">
            <app-validate-referral
              [capture]="capture"
              [patientPrescriber]="patientPrescriber" />
          </section>
          <section id="ceReviewDetails"><app-ce-review-details [capture]="capture" /></section>
          <section id="patientPrescriptions">
            <app-patient-prescriptions [capture]="capture" />
          </section>
          <section id="consultNoteVerification">
            <app-capture-consult-note-verification [capture]="capture" />
          </section>
          @if (showClientPrescriptionMatches) {
            <section id="clientPrescriptionMatches"
              >
              <app-client-prescription-matches [capture]="capture" />
            </section>
          }
          <section id="validatePatientCareOwnership">
            <app-validate-patient-care-ownership [capture]="capture" />
          </section>
          <section id="captureVerification">
            <app-capture-verification
              [capture]="capture"
              [patientPrescriber]="patientPrescriber"
              />
          </section>
          @if (capture.userAuditable || capture.userAuditOutcome) {
            <section id="captureUserAudit">
              <app-capture-user-audit [capture]="capture" />
            </section>
          }
        </div>
      }
      @default {
        <div class="capture-fixed mb-1">
          <app-capture-header [capture]="capture" />
          <div class="mt-1 capture-nav">
            <app-capture-nav
              [capture]="capture"
              [currentSection]="currentSection"
              (sectionClick)="onSectionClick($event)"
              />
          </div>
        </div>
        <div
          id="captureScrollable"
          class="capture-scrollable"
          appScrollSpy
          [spiedTags]="['SECTION']"
          (sectionChange)="onSectionScroll($event)"
          >
          @if (showValidateReferralSection) {
            <section id="validateReferral">
              <app-validate-referral
                [capture]="capture"
                [patientPrescriber]="patientPrescriber" />
            </section>
          }
          <section id="ceReviewDetails"><app-ce-review-details [capture]="capture" /></section>
          <section id="patientPrescriptions">
            <app-patient-prescriptions [capture]="capture" />
          </section>
          @if (showPatientDocumentsSection) {
            <section id="patientDocuments">
              <app-patient-documents
                [capture]="capture"
                [patientPrescriber]="patientPrescriber"
                [selectedAttachment]="selectedAttachment"
                (attachmentSelectionChange)="onAttachmentSelectionChange($event)"
                />
            </section>
          }
          @if (showClientPrescriptionMatches) {
            <section id="clientPrescriptionMatches"
              >
              <app-client-prescription-matches [capture]="capture" />
            </section>
          }
          <section id="validatePatientCareOwnership">
            <app-validate-patient-care-ownership [capture]="capture" />
          </section>
          @if (showValidatePrescriptionWrittenAtCe) {
            <section id="validatePrescriptionWrittenAtCe">
              <app-validate-prescription-written-at-ce [capture]="capture" />
            </section>
          }
          <section id="captureVerification">
            <app-capture-verification
              [capture]="capture"
              [patientPrescriber]="patientPrescriber"
              [selectedAttachment]="selectedAttachment"
              />
          </section>
          @if (capture.userAuditable || capture.userAuditOutcome) {
            <section id="captureUserAudit">
              <app-capture-user-audit [capture]="capture" />
            </section>
          }
        </div>
      }
    }
  </div>
} @else {
  <mat-spinner />
}
